import React, {useState} from 'react'

import {ProjectAccessMode} from "../../../model2/project/types"
import UserToAdd from "../../users/model/add-user"
import {ProjectAccess} from "../../../gd/const/project"
import UsersToAdd from "../../users/model/collection"
import FieldWorkspaceAccess from "../../../fields3/system/project/access/workpace-access"
import {FieldType} from "../../../fields3/field-type"
import FieldProjectAccess from "../../../fields3/system/project/access/project-access"
import UserIcon from "../../../gd-ui/icon/user/user"
import FieldFormElementView from "../../../fields3/render/form-elemnent-view"
import ProjectSession from "../../../model2/project/project-session"

type Props = {
    className?              : string

    targetProject?          : ProjectSession
    usersToAddToWorkspace   : UsersToAdd
    usersToAddToProject     : UsersToAdd

    showProjectAccess       : boolean
    showWorkspaceAccess     : boolean
}

export default function Modal_addUsers(props: Props) {

    const [renderKey, setRenderKey] = useState(0)

    const isInheritanceChildren = props.targetProject?.workspace?.project.accessMode === ProjectAccessMode.INHERITANCE_CHILDREN

    const onWorkspaceAccessChange = (userToAdd:UserToAdd, access:ProjectAccess) => {
        userToAdd.workspaceAccess = access

        if (isInheritanceChildren) {
            // project access can't be lower than workspace access in INHERITANCE_CHILDREN
            if (!userToAdd.projectAccess || userToAdd.projectAccess < userToAdd.workspaceAccess) {
                userToAdd.projectAccess = userToAdd.workspaceAccess
            }
        }

        setRenderKey(renderKey + 1)
    }

    const onProjectAccessChange = (userToAdd:UserToAdd, access:ProjectAccess) => {
        userToAdd.projectAccess = access
        setRenderKey(renderKey + 1)
    }

    const workspaceAccessField = new FieldWorkspaceAccess({
        type            : FieldType.WORKSPACE_ACCESS,
        fieldId         : 'workspaceAccess'
    })

    const projectAccessField = new FieldProjectAccess({
        type            : FieldType.PROJECT_ACCESS,
        fieldId         : 'projectAccess',
        minAccess       : ProjectAccess.LIMITED // project access is only visible when tasks are moved and task users may not have access lower than LIMITED
    })

    return (
        <>
            <div className={Classes("ui5-tabled-dashed w-100p", props.className)}>
                <div className="table-header">
                    <div className="cell flex-1">
                        <div className="ui5-title-small">
                            Users
                        </div>
                    </div>

                    {props.showWorkspaceAccess &&
                        <div className="cell w-160">
                            <div className="ui5-grid-header">
                                Workspace Access
                            </div>
                        </div>}

                    {props.showProjectAccess &&
                        <div className="cell w-160">
                            <div className="ui5-grid-header">
                                Project Access
                            </div>
                        </div>}
                </div>

                {_.map(props.usersToAddToWorkspace.available, (userToAdd:UserToAdd, key:number)=>{
                    const projectAccessFieldClone = _.cloneDeep(projectAccessField)
                    // project access can't be lower than workspace access in INHERITANCE_CHILDREN
                    if (props.targetProject?.workspace?.project.accessMode === ProjectAccessMode.INHERITANCE_CHILDREN) {
                        projectAccessFieldClone.minAccess = userToAdd.workspaceAccess
                    }

                    return (
                        <div className="table-row" key={'{0}_{1}'.f(key, renderKey)}>
                            <div className="cell flex-1 flex-row-left-center">
                                <UserIcon size="22" userId={userToAdd.id} className="m-r-8"/>
                                <div className="ui5-txt-default">{userToAdd.user.name}</div>
                            </div>

                            <div className="cell w-160">
                                <FieldFormElementView className = "w-140"
                                                      field     = {workspaceAccessField}
                                                      options   = {{size: '30'}}
                                                      model     = {userToAdd}
                                                      onChange  = {onWorkspaceAccessChange.bind(null, userToAdd)}/>
                            </div>

                            {props.showProjectAccess &&
                                <div className="cell w-160">
                                    <FieldFormElementView className = "w-140"
                                                          field     = {projectAccessFieldClone}
                                                          options   = {{size: '30'}}
                                                          model     = {userToAdd}
                                                          onChange  = {onProjectAccessChange.bind(null, userToAdd)}/>
                                </div>}
                        </div>
                    )
                })}

                {props.showProjectAccess && _.map(props.usersToAddToProject.available, (userToAdd:UserToAdd, key:number)=>{
                    return (
                        <div className="table-row" key={'{0}_{1}'.f(key, renderKey)}>
                            <div className="cell flex-1 flex-row-left-center">
                                <UserIcon size="22" userId={userToAdd.id} className="m-r-8"/>
                                <div className="ui5-txt-default">{userToAdd.user.name}</div>
                            </div>

                            <div className="cell w-160">
                                <FieldFormElementView className = "w-140"
                                                      field     = {projectAccessField}
                                                      options   = {{size: '30'}}
                                                      model     = {userToAdd}
                                                      onChange  = {onProjectAccessChange.bind(null, userToAdd)}/>
                            </div>
                        </div>
                    )
                })}
            </div>
        </>
    )
}
